module.exports = __webpack_public_path__ + "assets/img/close.b3fc6837.png";